import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { QuerySortEntryImpl } from "../model/impl/QuerySortEntryImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class QuerySortEntryImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: QuerySortEntryImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        QuerySortEntryImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.fieldName != null) {
      this.baseEncoder.writeStartFid(551, streamout);
      this.baseEncoder.writeObject(
        false,
        QuerySortEntryImplEncoder.fidTypeMap.get(551),
        false,
        encodable.fieldName,
        streamout,
      );
      this.baseEncoder.writeEndFid(551, streamout);
    }
    /*Object encoding*/
    if (encodable.isAscedenting != null) {
      this.baseEncoder.writeStartFid(552, streamout);
      this.baseEncoder.writeObject(
        false,
        QuerySortEntryImplEncoder.fidTypeMap.get(552),
        false,
        encodable.isAscedenting,
        streamout,
      );
      this.baseEncoder.writeEndFid(552, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,QuerySortEntryImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [551, "java.lang.String"],
    [552, "java.lang.Boolean"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: QuerySortEntryImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            QuerySortEntryImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 551: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            QuerySortEntryImplEncoder.fidTypeMap.get(551),
            streamin,
          );
          encodable.fieldName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 552: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            QuerySortEntryImplEncoder.fidTypeMap.get(552),
            streamin,
          );
          encodable.isAscedenting = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,QuerySortEntryImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return QuerySortEntryImplEncoder.fidTypeMap.has(fid);
  }
}
